import { ReactNode, useCallback } from 'react';

import { trackWizardSeen } from '@cartwhl/common/utils/trackWizardSeen';
import { markWizardStarted } from '@cartwhl/common/utils/wizardPersistence';
import {
  type WizardEndDetails,
  type WizardEndReason,
  WizardHost,
  WizardProvider,
} from '@cartwhl/ui/wizard';

import CanvasWizardAutoLaunch from './CanvasWizardAutoLaunch';
import { CANVAS_WIZARD_USER_STARTED_KEY_BY_ID } from './canvasWizards';

export default function CanvasWizardProvider({
  children,
}: {
  children: ReactNode;
}) {
  const handleWizardEnd = useCallback(
    (wizardId: string, reason: WizardEndReason, details?: WizardEndDetails) => {
      if (reason !== 'completed' && reason !== 'ended') {
        return;
      }

      const wizardType = CANVAS_WIZARD_USER_STARTED_KEY_BY_ID[wizardId];
      if (!wizardType) {
        return;
      }

      void markWizardStarted(wizardType);
      trackWizardSeen({
        eventSource: 'studio',
        app: 'studio',
        wizardType,
        outcome: reason === 'completed' ? 'completed' : 'dismissed',
        ...(reason === 'ended'
          ? { lastStepSeen: details?.lastStepSeen ?? 1 }
          : {}),
      });
    },
    [],
  );

  return (
    <WizardProvider onWizardEnd={handleWizardEnd}>
      {children}
      <CanvasWizardAutoLaunch />
      <WizardHost />
    </WizardProvider>
  );
}
